/**
 * Register Component
 */
(function (itxApp) {

    'use strict';

    /**
     * Register Component
     */
    var ItxChangePasswordCmp = {
        bindings: {},
        require: {
            'userAccessCtrl': '^itxUserAccess'
        },
        controller: ItxChangePasswordCmpCtrl,
        controllerAs: 'changePasswordCtrl',
        templateUrl: 'change-password.tpl'
    };

    ItxChangePasswordCmpCtrl.$inject = [
        '$scope', 
        'ItxErrorMessagesFct', 
        'imAccessService',
        'ItxLoginSvc',
        'NavigationService',
        'ngDialog',
        'NostromoSvc'
    ];

    function ItxChangePasswordCmpCtrl(
        $scope, 
        ItxErrorMessagesFct,
        imAccessService,
        ItxLoginSvc,
        NavigationService,
        ngDialog,
        NostromoSvc
    ) {
        var _this = this;

        _this.changeForm = null;
        _this.passwordValid=false;
        _this.hasOneNumber = true;
        _this.isLengthMin = true;
        _this.isLowerOneCharacter = true;
        _this.isUpperOneCharacter = true;
        _this.isRepeatCharacter = true;
        _this.captchaId = null;
        _this.showCaptcha = false;
         _this.validatePassword= function(){
            
             if(_this.password === undefined){
                _this.password= '';
            }
            
            var hasNumber= /\d/.test(_this.password);
            _this.hasOneNumber = !hasNumber;
            
            
            var length= /.{8,}/.test(_this.password); 
            _this.isLengthMin = !length;

            var patternLowerOneCharacter = new RegExp('.*[a-z]');
            var isLoChar=  patternLowerOneCharacter.test(_this.password);
            _this.isLowerOneCharacter = !isLoChar;
            
            var patternUpperOneCharacter = new RegExp('.*[A-Z]');
            var isUpChar=  patternUpperOneCharacter.test(_this.password);
            _this.isUpperOneCharacter = !isUpChar;

            _this.isRepeatCharacter = !_this.isRepeatChar();

            var passWordValid= _this.isRepeatChar() &&  
                                !_this.hasOneNumber &&  
                                !_this.isLengthMin && 
                                !_this.isLowerOneCharacter && 
                                !_this.isUpperOneCharacter ;

             _this.passwordValid= passWordValid;

        };
        


         _this.isRepeatChar = function () {
            if(_this.password ===''){
                return false;
            }else{
                var d = _this.password;
                return   /^(?!.*(.)\1{3})^.*$/.test(d);
            }
        };

       

        _this.resetErrorMessages = function () {
            if (ItxErrorMessagesFct.any('userAccessCtrl', 'ERROR')) {
                ItxErrorMessagesFct.reset('userAccessCtrl', 'ERROR');
            }
        };

        _this.changePassword = function () {
            _this.activationCode = inditex.iUrlJSON.params['hash'] || _this.userAccessCtrl.getActivationCode();
            _this.changeForm.$setSubmitted();
            _this.resetErrorMessages();

            if (_this.changeForm.$valid) {


                var captchaObj = {
                    'captchaId': _this.captchaId,
                    'captchaValue': _this.captcha
                };

                joyr.rest.xRestUpdateResetUserPassword(_this.userAccessCtrl.login, _this.activationCode,
                     _this.password, captchaObj)
                    .done(function () {
                        NostromoSvc.recoverPasswdDone();
                        _this.userAccessCtrl.show('change-password-success');
                        if(_this.userAccessCtrl.login) {
                            ItxLoginSvc.login(_this.userAccessCtrl.login, _this.password);
                        } else {
                            var login = inditex.base64.decode(inditex.iUrlJSON.params.hash).split('#')[0];
                            ItxLoginSvc.login(login, _this.password);
                        }
                        imAccessService.createEvent('recuperar_contrasena','modificar_contrasena_ok');
                    })
                    .Catch(function (error) {
                        _this.handleErrors(error);
                    })
                    .Finally(function () {
                        $scope.$broadcast('captcha:reloadImage');
                        $scope.$apply();
                    });

            }
            else {
                /**
                 * IManalytics errores formulario recuperar_contrasena
                 */
                imAccessService.createForm('recuperar_contrasena', _this.changeForm);
            }
        };

        _this.back = function () {
            _this.userAccessCtrl.closeDialog();
            imAccessService.createEvent('recuperar_contrasena' , 'ver_cuenta');
            NavigationService.goTo('ItxMyAccountPage');
        };


        // Funcion para la captura de errores
        _this.handleErrors = function(error) {

            // Acciones en caso de que el enlace de recuperación haya caducado
            // o lo hayamos introducido demasiadas veces
            if(error.errorKey === '_WARN_PARAM_PASSWORD_ACTIVATION_CODE_NOT_VALID' ||
                error.errorKey === '_WARN_PARAM_EXCEED_ACTIVATION_CODE_ATTEMPTS') {

                // Cierra todas las modales previamente abiertas
                ngDialog.closeAll();

                // Abre la modal de recuperación de contraseña de tipo enlace expirado
                ngDialog.open({
                    template: 'user-access-dialog-wrapper.tpl',
                    className: 'new-modal ma-modal-md ma-modal-macro recover-dialog ngdialog-theme-plain',
                    showClose: true,
                    bindToController: true,
                    data: 'recover-password-expired-link'
                });
            }
            else { 
                // Acciones en caso de que el error sea de otro tipo
                ItxErrorMessagesFct.add(error.errorMessage, 'userAccessCtrl', 'ERROR');
                imAccessService.createServer('recuperar_contrasena',  _this.changeForm, error);
            }
        }

    }

    /** Public */
    angular.module('itxApp.common')
        .component('itxChangePassword', ItxChangePasswordCmp);

    itxApp.common.ItxChangePasswordCmp = ItxChangePasswordCmp;
    itxApp.common.ItxChangePasswordCtrl = ItxChangePasswordCmpCtrl;

})(window.itxApp);
